/**
 * @generated SignedSource<<3722d018c0f0850a19dbbb39545c1e98>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CarouselThumb_videoVimeo$data = {
  readonly fileByVideoSize: {
    readonly link: string | null;
  } | null;
  readonly " $fragmentType": "CarouselThumb_videoVimeo";
};
export type CarouselThumb_videoVimeo$key = {
  readonly " $data"?: CarouselThumb_videoVimeo$data;
  readonly " $fragmentSpreads": FragmentRefs<"CarouselThumb_videoVimeo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CarouselThumb_videoVimeo",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "small"
        }
      ],
      "concreteType": "VideoVimeoFile",
      "kind": "LinkedField",
      "name": "fileByVideoSize",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "link",
          "storageKey": null
        }
      ],
      "storageKey": "fileByVideoSize(size:\"small\")"
    }
  ],
  "type": "VideoVimeo",
  "abstractKey": null
};

(node as any).hash = "58f0e93aadfe3a6e160dd6f83fb9c29f";

export default node;
